import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

const ProductResponseTimeRecord = Record({
  min: {
    value: 0,
    description: '',
  },
  max: {
    value: 0,
    description: '',
  },
  average: {
    value: 0,
    description: '',
  },
});

export default class ProductResponseTime extends ProductResponseTimeRecord {
  static deserialize(jsonObject = {}) {
    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject), {});

    return new ProductResponseTime(hydrated);
  }
}
